import React from 'react';
import './PanelTable.scss';

export default function PanelTable ({ render, order, activeOrder, dir, headers = [], items = [], panelStyle = {}, trStyle = {}, thStyle = {}, tdStyle={} }) {
    
    const upArrow = <span className="material-symbols-outlined material-icons">
        expand_less
    </span>

    const downArrow = <span className="material-symbols-outlined material-icons">
        keyboard_arrow_down
    </span>

    const canToggle = <span className="material-symbols-outlined material-icons">
            unfold_more
        </span>

    return (
        <div className='panel-table-wrap'>
            <table className='panel-table' style={panelStyle}>
                <thead>
                    <tr style={trStyle}>
                        {headers.map((h, k)=>{
                            const orderDir = dir === 'asc' ? 'desc' : 'asc';
                            const label = typeof h === 'string' ? h : h.label;
                            const onclick = typeof h === 'object' && h.order_key ? ()=>order(h.order_key, orderDir) : null;
                            return (
                                <th 
                                    onClick={onclick}
                                    key={k}
                                    style={thStyle}
                                >
                                    <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4, cursor: onclick ? 'pointer': 'inherit' }}>
                                        {label} 
                                        {
                                            onclick ? (
                                                (h.order_key === activeOrder ? (orderDir === 'asc' ? downArrow : (orderDir === 'desc' ? upArrow : '')) : (canToggle))
                                            ) : null
                                        }
                                    </span>
                                    
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, k)=><tr style={trStyle} key={k}>{render(item)}</tr>)}
                </tbody>
            </table>
        </div>
    )
}